import React, { useState, useRef, useEffect } from 'react';
import classnames from 'classnames';
import { isChildOfType } from '../_utils/isChildOfType';
import { SwitchButtonProps } from './interface';

import SwitchButtonContext from './SwitchButtonContext';
import SwitchButtonItem from './SwitchButtonItem';

const SwitchButton: React.FC<SwitchButtonProps> = (props) => {
  const { defaultId, children, direction, shape, onChange, className, style } =    props;

  let prefixCls = 'switch-button';
  const classes = classnames(prefixCls, className, {
    [`is-${direction}`]: !!direction,
    [`is-${shape}`]: !!shape,
  });

  /* ---------- state ---------- */
  // 激活的id
  const [activeId, setActiveId] = useState<undefined | string | number>(defaultId);
  const [handleStyle, setHandleStyle] = useState({ left: 0, width: 0 });
  const [handleVertical, setHandleVertical] = useState({ top: 0, height: 0 });
  /* ---------- ref ---------- */
  // 当前激活节点
  const currentItemRef = useRef<any>(null);

  /* ---------- function ---------- */
  // 渲染函数
  const renderItem = () => {
    const itemChildren: any = [];

    React.Children.forEach(children, (child: any, index) => {
      if (isChildOfType(child, SwitchButtonItem)) {
        const { props, key } = child;

        let active = activeId === props.id;

        if (!activeId && index === 0) {
          active = true;
        }
        itemChildren.push(React.cloneElement(child, {
          active,
          key: key || props.id,
          onClick: () => {
            if (activeId !== props.id) {
              setActiveId(props.id);
            }
            onChange?.(props);
          },
        }));
      }
    });

    return itemChildren;
  };

  const handleResize = () => {
    setHandleStyle({
      left: currentItemRef.current.offsetLeft,
      width: currentItemRef.current.offsetWidth,
    });
  };

  // 激活按钮时zhi ding
  useEffect(() => {
    if (!currentItemRef.current) return;

    setHandleStyle({
      left: currentItemRef.current.offsetLeft,
      width: currentItemRef.current.offsetWidth,
    });
    setHandleVertical({
      top: currentItemRef.current.offsetTop,
      height: currentItemRef.current.offsetHeight,
    });
  }, [activeId]);

  useEffect(() => {
    window.addEventListener('resize', handleResize)
  }, []);
  useEffect(() => {
    setActiveId(defaultId);
  }, [defaultId]);
  return (
    <div className={classes} style={style}>
      <div className={`${prefixCls}__inner`}>
        <div
          className={`${prefixCls}__handle`}
          style={
            direction === 'vertical' && handleStyle && handleVertical
              ? {
                transform: `translateY(${handleVertical.top}px)`,
                height: `${handleVertical.height}px`,
              }
              : {
                transform: `translateX(${handleStyle.left}px)`,
                width: `${handleStyle.width}px`,
              }
          }
        ></div>
        <div className={`${prefixCls}__bar`}>
          <SwitchButtonContext.Provider
            value={{
              currentItemRef,
            }}
          >
            {renderItem()}
          </SwitchButtonContext.Provider>
        </div>
      </div>
    </div>
  );
};
SwitchButton.defaultProps = {};

export default SwitchButton;
